import PageTitleAndSub from '../PageTitleAndSub';
import React from 'react';
import styled from 'styled-components';
import { useOktaAuth } from '@okta/okta-react';

const Borderline = styled.div`
  margin-top: 2%;
  border-top: 1px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 2%;
`;
export default function WelcomeBannerHome({ subtitle }: { subtitle: string }) {
  const okta = useOktaAuth();
  const name = okta.authState?.idToken?.claims?.name ?? 'Bird Enthusiast';

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div style={{ flexBasis: '20%' }}>
          <PageTitleAndSub title={'Welcome, ' + name} subtitle={subtitle} />
        </div>
      </div>
      <Borderline />
    </>
  );
}
